export default "__VITE_ASSET__m6LIZyt2__"